import type { LearnerFeedbackFeaturedAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type AssociationDefinitions,
  type GroupBy,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryLimitToSQL,
  queryOrderToSQL,
} from './common'
import LearnerFeedbackQ from './LearnerFeedbackQ'

const LearnerFeedbackFeaturedQ = {
  ...makeQueryModelV2<LearnerFeedbackFeaturedAttributes>('learner_feedback_featured')([
    'id',
    'learner_feedback_id',
    'user_id',
    'created_at',
    'updated_at',
    'deleted_at',
  ]),

  associations: (): AssociationDefinitions => ({
    LearnerFeedback: {
      query: LearnerFeedbackQ,
      foreignKey: LearnerFeedbackQ.id,
      sourceKey: LearnerFeedbackFeaturedQ.learner_feedback_id,
    },
  }),

  where: (
    {
      learnerFeedbackId,
      paranoid = true,
      userId,
      include = [],
      groupBy = null,
      order = null,
      limit = null,
    }: {
      learnerFeedbackId?: number | null | SQLFragment<number>
      paranoid?: boolean
      userId?: number | null | SQLFragment<number>
      include?: IncludeAssociations
      groupBy?: GroupBy | null
      order?: QueryOrder | null
      limit?: number | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<LearnerFeedbackFeaturedAttributes> => SQL`
        FROM ${LearnerFeedbackFeaturedQ}
        ${includeAssociationsToSql(LearnerFeedbackFeaturedQ, include)}
        WHERE
            ${
              learnerFeedbackId != null
                ? SQL`${LearnerFeedbackFeaturedQ.learner_feedback_id} = ${learnerFeedbackId} AND`
                : SQL``
            }
            ${userId != null ? SQL`${LearnerFeedbackFeaturedQ.user_id} = ${userId} AND` : SQL``}
            ${paranoid ? SQL`${LearnerFeedbackFeaturedQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
        ${queryLimitToSQL(limit)}
    `,
}

export default LearnerFeedbackFeaturedQ
